import { render, staticRenderFns } from "./SettingsDatepicker.vue?vue&type=template&id=40d873f6&scoped=true"
import script from "./SettingsDatepicker.vue?vue&type=script&lang=js"
export * from "./SettingsDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d873f6",
  null
  
)

export default component.exports